<!--
이미지 변경 컴포넌트
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">상품이미지 수정 방법을 선택하세요</h4>
            </div>

            <div class="uk-modal-body">

                <div class="uk-flex uk-flex-around uk-flex-top">
                    <!-- url직접입력 -->
                    <div
                        class="change-type-button"
                        @click="modalInputUrl"
                    >
                        <i class="material-icons">edit</i>
                        <div class="text">
                            URL 직접입력
                        </div>
                    </div>

                    <!-- 업로드 -->
                    <div
                        class="change-type-button"
                        @click="modalImageUpload"
                    >
                        <i class="material-icons">cloud_upload</i>
                        <div class="text">
                            이미지 업로드
                        </div>
                    </div>


                    <!-- 첨부파일 -->
                    <div
                        class="change-type-button"
                        @click="modalChoiceOfFiles"
                    >
                        <i class="material-icons">photo_library</i>
                        <div class="text">
                            첨부파일 중 선택
                        </div>
                    </div>

                </div>

            </div>


            <div class="uk-modal-footer uk-text-center">

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
            </div>
        </div>

        <!-- url 컴포넌트 -->
        <url :csrf-token="csrfToken" ref="url"></url>

        <!-- 업로드 컴포넌트 -->
        <upload :csrf-token="csrfToken" ref="upload"></upload>

        <!-- 첨부파일 컴포넌트 -->
        <files :csrf-token="csrfToken" ref="files"></files>
    </div>

</template>

<script>
    export default {
        components: {
            'url': require('./img-changer/url.vue').default,
            'upload': require('./img-changer/upload.vue').default,
            'files': require('./img-changer/files.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param prod_id 상품ID
             */
            form(prod_id) {

                // 초기화
                this.inputs = {
                    reason: null,
                };

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.prod = response.prod;

                    // 폼띄우기
                    this.displayForm();
                });
            },


            /**
             * url 직접입력 모달창
             */
            modalInputUrl() {
                this.$refs.url.form(this.prod);
            },

            /**
             * 이미지 업로드 모달창
             */
            modalImageUpload() {
                this.$refs.upload.form(this.prod);
            },

            /**
             * 첨부파일 중 모달창
             */
            modalChoiceOfFiles() {
                this.$refs.files.form(this.prod);
            },
        },


    }
</script>

<style lang="scss" scoped>
    .change-type-button {
        padding: 10px;
        border: 1px solid #cfcfcf;
        cursor: pointer;
        text-align: center;
        background-color: #666;
        color: #fff;

        &:hover {
            background-color: #333;
        }

        .material-icons {
            font-size: 3rem;
        }

        .text {
            margin-top: 10px;
        }
    }
</style>